
import { Action, Getter } from 'vuex-class'
import CalendarPicker from '@/components/calendar/calendar-picker.vue'
import { Device } from '@/store/types'
import { Options, Vue } from 'vue-class-component'
import { ResponseData } from '@/datamodel/response-data'

import { useI18n } from 'vue-i18n'
import router from '@/router'
import { getBetHistory, getBetHistoryDetails } from '@/api'
import { EventBuss } from '@/utils/constants'
import { BetRecord, BetRecordInfo } from 'vue'

@Options({
    components: {
        CalendarPicker
    }
})
export default class HistoryView extends Vue {
    iN = useI18n().t
    isMobile = false
    showDetails = false
    startDate = new Date()
    endDate = new Date()
    selectedDate = null

    $emit!: Vue['emit']
    emitter!: Vue['emitter']

    betRecord: BetRecord[] = []
    betRecordInfo: BetRecordInfo[] = []

    cardFaces = ['♠', '♥', '♣', '♦']

    @Getter('userId') uid!: string
    @Getter('device') device!: Device
    @Getter('token') token!: string
    @Getter('memberId') memberId!: number

    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void

    //#region Vue Methods
    beforeMount(): void {
        this.isMobile = this.device.display === 1

        // const betlog = new BetLog()
        // betlog.mday = new Date().toISOString().substring(0, 10)
        // betlog.sumPointed = 0
        // betlog.count = 2
        // this.betLogs.push(betlog)

        // const betlogdet = new BetLogDeatails()
        // betlogdet.gameid = '121221'

        // this.betLogDetails.push(betlogdet)
    }

    mounted(): void {
        this.OnClickViewBetHistory()

        // alert(window.innerWidth)
        // console.log(window.innerWidth, 'hello')
    }
    //#endregion

    OnClickClose(): void {
        // EventBus.$emit(EventBusEvents.SHOW_DIALOGS, Dialog.HISTORY_VIEW)
        this.$emit('on-close')
    }

    OnStartDateChange(date: Date): void {
        date.setHours(0, 0, 0)
        this.startDate = date
    }

    OnEndDateChange(date: Date): void {
        date.setHours(23, 59, 59, 0)
        this.endDate = date
    }

    OnClickViewBetHistory(): void {
        if (this.startDate && this.endDate) {
            this.showLoading()

            const _param = {
                token: this.token,
                memberId: this.memberId,
                timestart: this.startDate.getTime(),
                timeend: this.endDate.getTime()
            }

            getBetHistory(_param)
                .then(r => {
                    this.hideLoading()
                    const response = r.data

                    if (response.status === 200) {
                        this.betRecord = response.data.betRecordSummaryList
                    } else {
                        this.emitter.emit(
                            EventBuss.TOAST_MESSAGE,
                            response.description
                        )
                    }
                })
                .catch(() => {
                    this.hideLoading()
                    this.emitter.emit(
                        EventBuss.TOAST_MESSAGE,
                        this.iN('prompt.networkerror')
                    )
                })
        }
    }

    OnClickLogsItem(s: string): void {
        this.betRecordInfo = []
        const timeStamp = new Date(s).getTime()
        this.showDetails = true
        this.showLoading()

        const _params = {
            memberId: this.memberId,
            token: this.token,
            timestart: timeStamp,
            timeend: timeStamp
        }

        getBetHistoryDetails(_params)
            .then(r => {
                this.hideLoading()
                const response = r.data

                if (response.status === 200) {
                    this.betRecordInfo = response.data.betRecordList.items
                } else {
                    this.emitter.emit(
                        EventBuss.TOAST_MESSAGE,
                        response.description
                    )
                }
            })
            .catch(() => {
                this.hideLoading()
            })
    }

    getGameResult(info: BetRecordInfo) {
        let b = info.expand.gameResultData ?? ''

        if (b === '') return ''

        const {
            playerOne,
            playerThree,
            playerTwo,
            bankerOne,
            bankerTwo,
            bankerThree
        } = info.expand

        const rl = this.redLabel(info.gameTypeNo)
        const bl = this.bluelabel(info.gameTypeNo)

        const rHands: string[] = []
        const bHands: string[] = []

        if (playerOne) bHands.push(playerOne)
        if (playerTwo) bHands.push(playerTwo)
        if (playerThree) bHands.push(playerThree)

        if (bankerOne) rHands.push(bankerOne)
        if (bankerTwo) rHands.push(bankerTwo)
        if (bankerThree) rHands.push(bankerThree)

        const rc = this.readCards(rHands)
        const bc = this.readCards(bHands)

        return `${b}( ${rl} : ${rc} ${bl} : ${bc} )`
    }

    getGameResultLabel(info: BetRecordInfo) {
        return info.expand.gameResultData ?? ''
    }

    redLabel(gType: string) {
        let label = ''

        if (gType === 'G002') return '庄'
        else if (gType === 'G003') return '龙'

        return label
    }

    bluelabel(gType: string) {
        let label = ''
        if (gType === 'G002') return '閒'
        else if (gType === 'G003') return '虎'
        return label
    }

    readCards(cards: string[]) {
        let result = ''

        cards.forEach((x, index) => {
            const fValue = this.getDTFaceValue(x)
            const cValue = this.getColorValue(x)

            let cS = `${fValue}`

            if (fValue === 11) cS = 'J'
            else if (fValue === 12) cS = 'Q'
            else if (fValue === 13) cS = 'K'
            else if (fValue === 1) cS = 'A'

            let ll = ''

            if (index > 0) ll = ' '

            result += `${ll}${this.cardFaces[cValue - 1]}${cS}`
        })

        return result
    }

    roundFixed2(_value = 0): number {
        return +_value.toFixed(2)
    }

    minDate() {
        const days = 45
        const date = new Date()
        const last = new Date(date.getTime() - days * 24 * 60 * 60 * 1000)
        const day = last.getDate()
        const month = last.getMonth() + 1
        const year = last.getFullYear()
        return new Date(`${month}/${day}/${year}`)
    }

    getDTFaceValue(code: string): number {
        if (code.length !== 4) return 0
        return parseInt(code.substr(1, 2))
    }

    getColorValue(code: string): number {
        if (code.length !== 4) return 0
        return parseInt(code.substr(0, 1))
    }

    handleBetTypeData(row: BetRecordInfo | any) {
        // const multiplier = 10000
        return `${row.betTypeDataOne
            ? `${row.betTypeDataOne}(${row.betAmountOne})`
            : ''
            } ${row.betTypeDataTwo
                ? `${row.betTypeDataTwo}(${row.betAmountTwo})`
                : ''
            } ${row.betTypeDataTie
                ? `${row.betTypeDataTie}(${row.betAmountTie})`
                : ''
            } ${row.betTypeDataZdui
                ? `${row.betTypeDataZdui}(${row.betAmountZdui})`
                : ''
            } ${row.betTypeDataXdui
                ? `${row.betTypeDataXdui}(${row.betAmountXdui})`
                : ''
            } ${row.betTypeDataZhuangFree
                ? `${row.betTypeDataZhuangFree}(${row.betAmountZhuangFree})`
                : ''
            } ${row.betTypeDataSuperSix
                ? `${row.betTypeDataSuperSix}(${row.betAmountSuperSix})`
                : ''
            }  ${row.betTypeDataBigTiger
                ? `${row.betTypeDataBigTiger}(${row.betAmountBigTiger})`
                : ''
            }${row.betTypeDataDragonSeven
                ? `${row.betTypeDataDragonSeven}(${row.betAmountDragonSeven})`
                : ''
            }${row.betTypeDataBearEight
                ? `${row.betTypeDataBearEight}(${row.betAmountBearEight})`
                : ''
            }${row.betTypeDataSmallTiger
                ? `${row.betTypeDataSmallTiger}(${row.betAmountSmallTiger})`
                : ''
            }
        `
    }

    get showCommission() {
        return (
            this.betRecord.length > 0 && this.betRecord[0].expand.showCommission
        )
    }
}
